var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M503.237,98.953V79.694c0-3.736-2.718-6.916-6.408-7.499l-10.316-1.629c-2.136-0.337-3.951-1.778-4.713-3.802 c-0.529-1.406-1.106-2.788-1.729-4.145c-0.907-1.977-0.65-4.294,0.629-6.053l6.151-8.458c2.197-3.021,1.87-7.192-0.772-9.833 l-13.618-13.618c-2.642-2.642-6.812-2.969-9.833-0.772l-8.458,6.151c-1.759,1.28-4.076,1.536-6.053,0.629 c-1.357-0.623-2.739-1.2-4.145-1.729c-2.024-0.762-3.465-2.577-3.802-4.713l-1.629-10.316c-0.583-3.69-3.763-6.408-7.499-6.408 h-19.259c-3.736,0-6.916,2.718-7.499,6.408l-1.629,10.316c-0.337,2.136-1.778,3.951-3.802,4.713 c-1.406,0.529-2.787,1.106-4.145,1.729c-1.977,0.907-4.294,0.65-6.053-0.629l-8.458-6.151c-3.021-2.197-7.192-1.87-9.833,0.772 l-13.618,13.618c-2.642,2.642-2.969,6.812-0.772,9.833l6.151,8.458c1.28,1.759,1.536,4.076,0.629,6.053 c-0.623,1.357-1.2,2.739-1.729,4.145c-0.762,2.024-2.577,3.465-4.713,3.802l-10.316,1.629c-3.69,0.583-6.408,3.763-6.408,7.499 v19.259c0,3.736,2.718,6.916,6.408,7.499l10.316,1.629c2.136,0.337,3.951,1.778,4.713,3.802c0.529,1.406,1.106,2.787,1.729,4.145 c0.907,1.977,0.65,4.294-0.629,6.053l-6.151,8.458c-2.197,3.021-1.87,7.192,0.772,9.833l13.618,13.618 c2.642,2.642,6.812,2.969,9.833,0.772l8.458-6.151c1.759-1.28,4.076-1.536,6.053-0.629c1.357,0.623,2.739,1.2,4.145,1.729 c2.024,0.762,3.465,2.577,3.802,4.713l1.629,10.316c0.583,3.69,3.763,6.408,7.499,6.408h19.259c3.736,0,6.916-2.718,7.499-6.408 l1.629-10.316c0.337-2.136,1.778-3.951,3.802-4.713c1.406-0.529,2.787-1.106,4.145-1.729c1.977-0.907,4.294-0.65,6.053,0.629 l8.458,6.151c3.021,2.197,7.192,1.87,9.833-0.772l13.618-13.618c2.642-2.642,2.969-6.812,0.772-9.833l-6.151-8.458 c-1.28-1.759-1.536-4.076-0.629-6.053c0.623-1.357,1.2-2.739,1.729-4.145c0.762-2.024,2.577-3.465,4.713-3.802l10.316-1.629 C500.52,105.869,503.237,102.688,503.237,98.953z M421.414,116.598c-15.063,0-27.274-12.211-27.274-27.274 c0-15.063,12.211-27.274,27.274-27.274s27.274,12.211,27.274,27.274C448.689,104.386,436.477,116.598,421.414,116.598z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 88.06,
    cy: 42.567,
    r: 35.067
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M105.557,171.15h23.27c9.27,0,16.79-7.52,16.79-16.79v-19.18c0-31.79-25.77-57.54-57.56-57.55 c-31.78,0.01-57.55,25.76-57.55,57.55v19.18c0,9.27,7.52,16.79,16.79,16.79h23.26"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 254.737,
    cy: 256,
    r: 81.823
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.451,245.04l11.429,11.429l27.143-27.143c6.312-6.312,16.545-6.312,22.857,0l0,0c6.312,6.312,6.312,16.545,0,22.857 l-38.572,38.572c-6.312,6.312-16.545,6.312-22.857,0l-22.857-22.857c-6.312-6.312-6.312-16.545,0-22.857l0,0 C218.906,238.729,229.139,238.729,235.451,245.04z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 85.535,
    y1: 472.175,
    x2: 85.535,
    y2: 504.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.735,
    y1: 373.179,
    x2: 120.386,
    y2: 373.179
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.735,
    y1: 406.178,
    x2: 120.386,
    y2: 406.178
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 55.735,
    y1: 439.176,
    x2: 120.386,
    y2: 439.176
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M23.407,427.41v77.09h129.3V357.02c0-8.93-7.23-16.17-16.16-16.17h-96.97c-8.93,0-16.17,7.24-16.17,16.17v35.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 209.28,
    y1: 89.323,
    x2: 300.195,
    y2: 89.323
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 275.951,65.079 300.195,89.323 275.951,113.567 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 421.414,
    y1: 210.543,
    x2: 421.414,
    y2: 301.457
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 445.658,277.213 421.414,301.457 397.17,277.213 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 300.195,
    y1: 422.677,
    x2: 209.28,
    y2: 422.677
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 233.524,446.921 209.28,422.677 233.524,398.433 \t\t\t"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 167.358,
    y1: 504.5,
    x2: 8.763,
    y2: 504.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M455.76,373.179h20.203c6.697,0,12.122,5.425,12.122,12.122v107.077c0,6.697-5.425,12.122-12.122,12.122h-74.752 c-6.697,0-12.122-5.425-12.122-12.122v-20.203"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M356.767,420.09v39.96c0,6.7,5.42,12.12,12.12,12.12h74.75c6.7,0,12.12-5.42,12.12-12.12v-93.97c0-3.22-1.27-6.3-3.55-8.57 l-13.1-13.11c-2.27-2.27-5.36-3.55-8.57-3.55h-61.65c-6.7,0-12.12,5.43-12.12,12.13v32.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.089,
    y1: 373.179,
    x2: 423.434,
    y2: 373.179
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.089,
    y1: 406.178,
    x2: 423.434,
    y2: 406.178
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.089,
    y1: 439.176,
    x2: 406.262,
    y2: 439.176
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.26351ae5f68189f1927c51a1fcc514fe.svg";
export { ForwardRef as ReactComponent };